/**
 * Sticky Add to Cart Panel Custom Element
 * Shows/hides based on main ATC button visibility
 * Uses product-form component for add to cart functionality
 */

class StickyAtcPanel extends HTMLElement {
  constructor() {
    super();

    this.isVisible = false;
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    this.setupIntersectionObserver();
  }

  /**
   * Setup IntersectionObserver to detect when main ATC button is in viewport
   */
  setupIntersectionObserver() {
    // Find the main ATC button container
    const mainAtcContainer = document.querySelector(".product-form__buttons");

    if (!mainAtcContainer) {
      console.warn("Sticky ATC: Main ATC button container not found");
      return;
    }

    const options = {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Get the bounding rect to determine position relative to viewport
        const rect = entry.boundingClientRect;
        const isAboveFold = rect.bottom < 0;

        if (isAboveFold) {
          // Main ATC is above the fold (scrolled past), show sticky panel
          this.showPanel();
        } else {
          // Main ATC is visible or below the fold, hide sticky panel
          this.hidePanel();
        }
      });
    }, options);

    this.observer.observe(mainAtcContainer);
  }

  /**
   * Show sticky panel
   */
  showPanel() {
    if (this.isVisible) return;
    this.isVisible = true;
    this.classList.add("is-visible");
  }

  /**
   * Hide sticky panel
   */
  hidePanel() {
    if (!this.isVisible) return;
    this.isVisible = false;
    this.classList.remove("is-visible");
  }

  /**
   * Cleanup
   */
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// Register the custom element
if (!customElements.get("sticky-atc-panel")) {
  customElements.define("sticky-atc-panel", StickyAtcPanel);
}
